// extracted by mini-css-extract-plugin
export default {"root":"AvailableSolutions_root__H-P0W","solutionCardContainer":"AvailableSolutions_solutionCardContainer__LSHWT"};